import { gql } from '@apollo/client';

export default {
  create: {
    name: 'createUserAddress',
    serviceName: 'auth',
    query: gql`
      mutation createUserAddress(
        $lat: String
        $lng: String
        $title: String!
        $is_default: Int
        $tellphone: String
        $main_street: String
        $minor_address: String
      ) {
        createUserAddress(
          lat: $lat
          lng: $lng
          title: $title
          tellphone: $tellphone
          is_default: $is_default
          main_street: $main_street
          minor_address: $minor_address
        ) {
          messages
        }
      }
    `,
  },
  update: {
    name: 'updateUserAddress',
    serviceName: 'auth',
    query: gql`
      mutation updateUserAddress(
        $lat: String
        $lng: String
        $title: String!
        $ids: [String]!
        $is_default: Int
        $tellphone: String
        $main_street: String
        $minor_address: String
      ) {
        updateUserAddress(
          lat: $lat
          lng: $lng
          ids: $ids
          title: $title
          tellphone: $tellphone
          is_default: $is_default
          main_street: $main_street
          minor_address: $minor_address
        ) {
          messages
        }
      }
    `,
  },
};
